module.exports = __webpack_public_path__ + "static/media/logoHSRegister.b81f1f69.png";